import React, { useEffect } from 'react';
import UploadImage from '@components/common/form/UploadImage';
import { STATUS_ACTIVE } from '@constants';
import { commonStatus } from '@constants/masterData';
import useTranslate from '@hooks/useTranslate';
import { SelectField, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { Col, Form, Row } from 'antd';
const GroupFoodForm = ({ detail, form, onSubmit, setIsChangedFormValues, actions }) => {
    const translate = useTranslate();

    useEffect(() => {
        if (detail) {
            form.setFieldsValue(detail);
        }
    }, [ detail ]);
    const handleSubmit = (values) => {
        if (detail) {
            values.id = detail.id;
        }
        values.groupSetting = detail ? detail.groupSetting : '{}';
        values.status = STATUS_ACTIVE;
        onSubmit(values);
    };
    return (
        <Form form={form} layout="vertical" onFinish={handleSubmit} onValuesChange={() => setIsChangedFormValues(true)}>
            <Row gutter={16}>
                <Col span={12}>
                    <TextField name="name" label={translate.formatMessage(commonMessage.groupFoodName)} required />
                </Col>
                <Col span={12}>
                    <TextField
                        name="description"
                        label={translate.formatMessage(commonMessage.description)}
                        type="textarea"
                    />
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={24}>
                    <UploadImage
                        formItemProps={{ labelAlign: 'left' }}
                        label={translate.formatMessage(commonMessage.image)}
                        name={'imagePath'}
                        aspect={1000 / 300}
                    />
                </Col>
            </Row>
        </Form>
    );
};

export default GroupFoodForm;
